import { WabaProvider } from "../whatsapp/waba-provider";

export interface AccountModel {
  companyName: string;
  companyContactNo: string;
  addrLine1: string;
  addrLine2: string;
  city: string;
  state: string;
  postcode: string;
  country: string;
  countryIsoCode: string;
  active: boolean;

  paymentExempted: boolean;

  wabaAutoReplyMessage: string;
  wabaProvider?: WabaProvider;

  wabaEmail?: string;
  wabaPassword?: string;
  wabaId?: string;
  wabaToken?: string;
  wabaGuid?: string;
  wabaName?: string;
  wabaMetaName?: string;
  wabaFireMobileName?: string;
  wabaNubitelName?: string;
  wabaPhone?: string;
  wabaPhoneId?: string;
  wabaWebhookId?: string;
  wabaWebhookUrl?: string;

  wabaMetaEmail?: string;
  wabaMetaPassword?: string;
  wabaMetaGuid?: string;
  wabaMetaToken?: string;
  wabaMetaId?: string;
  wabaMetaPhone?: string;
  wabaMetaPhoneId?: string;

  wabaFireMobileEmail?: string;
  wabaFireMobilePassword?: string;
  wabaFireMobileGuid?: string;
  wabaFireMobileToken?: string;
  wabaFireMobilePhone?: string;
  wabaFireMobilePhoneId?: string;

  wabaNubitelEmail?: string;
  wabaNubitelPassword?: string;
  wabaNubitelGuid?: string;
  wabaNubitelToken?: string;
  wabaNubitelPhone?: string;
  wabaNubitelPhoneId?: string;

  sftpHost?: string;
  sftpPort?: number;
  sftpUsername?: string;
  sftpPassword?: string;
}
